export type TipCategory = 'methode' | 'paris-hippiques' | 'strategie';

export interface TipEntry {
    slug: string;
    title: string;
    description: string;
    category: TipCategory;
}

export const TIPS_CATEGORIES: Record<TipCategory, { label: string; description: string }> = {
    methode: {
        label: 'Notre méthode',
        description: 'Comment ExpertTurf analyse les courses et détecte les opportunités.',
    },
    'paris-hippiques': {
        label: 'Paris hippiques',
        description: 'Les bases pour comprendre et lire un pari hippique.',
    },
    strategie: {
        label: 'Stratégie & bankroll',
        description: 'Comment parier intelligemment sur le long terme.',
    },
};

export const TIPS_ENTRIES: TipEntry[] = [
    {
        slug: 'notre-approche',
        title: 'Notre approche',
        description: "Comment nous construisons chaque pronostic à partir de la donnée.",
        category: 'methode',
    },
    {
        slug: 'le-score-elo',
        title: "Le score Elo appliqué aux courses hippiques",
        description: "Comment un système de classement issu des échecs permet de mesurer la vraie force d'un cheval.",
        category: 'methode',
    },
    {
        slug: 'reduction-kilometrique',
        title: 'La réduction kilométrique expliquée',
        description: 'Comprendre cet indicateur clé du trot et comment nous le calibrons.',
        category: 'methode',
    },
    {
        slug: 'detecter-les-outsiders',
        title: 'Comment détecter un outsider sous-coté',
        description: "La logique derrière notre système de détection de valeur.",
        category: 'methode',
    },
    {
        slug: 'simple-gagnant-place',
        title: 'Simple gagnant et placé : les bases',
        description: 'Comprendre les deux paris les plus simples pour débuter.',
        category: 'paris-hippiques',
    },
    {
        slug: 'comprendre-les-cotes',
        title: 'Comprendre les cotes',
        description: 'Comment lire une cote et ce qu\'elle signifie réellement.',
        category: 'paris-hippiques',
    },
    {
        slug: 'gestion-bankroll',
        title: 'Gérer sa bankroll',
        description: 'Les principes de base pour parier sur le long terme sans se ruiner.',
        category: 'strategie',
    },
    {
        slug: 'pourquoi-le-place',
        title: 'Pourquoi privilégier le pari placé',
        description: 'Notre raisonnement sur le choix du type de pari le plus cohérent.',
        category: 'strategie',
    },
];

export const getTipsByCategory = (category: TipCategory): TipEntry[] =>
    TIPS_ENTRIES.filter((entry) => entry.category === category);